export default __webpack_public_path__ + "static/media/container-tracking.cc73f05e.svg";